import { postListFetcher } from '@/shared/api/list';
import { DeleteButton } from '@/shared/ui/list/DeleteButton';
import { FormModalButton, type EntityField } from '@/shared/ui/list/EntityFormModal';
import { GenericListPage } from '@/shared/ui/list/GenericListPage';
import type { ListPageConfig, ListRow } from '@/shared/ui/list/types';
import { deleteCategory, saveCategory } from './api';

const LIST_KEY = 'publications-categories';

interface Category extends ListRow {
  id: number;
  title?: string;
  body?: string;
  slug?: string;
  code?: string;
  status_id?: number | string;
}

const FIELDS: EntityField[] = [
  { name: 'title', label: 'Заголовок', placeholder: 'Заголовок...' },
  { name: 'body', label: 'Тело', placeholder: 'Тело...' },
  { name: 'slug', label: 'ЧПУ', placeholder: 'ЧПУ...' },
  { name: 'code', label: 'Код', placeholder: 'Код...' },
  {
    name: 'statusId',
    label: 'Статус',
    type: 'select',
    options: [
      { value: '0', label: 'Не опубликовано' },
      { value: '1', label: 'Опубликовано' },
    ],
  },
];

const toValues = (category?: Category) => ({
  title: category?.title ?? '',
  body: category?.body ?? '',
  slug: category?.slug ?? '',
  code: category?.code ?? '',
  statusId: String(category?.status_id ?? 0),
});

const save = (id?: number) => (v: Record<string, string | boolean>) =>
  saveCategory(id, {
    title: String(v.title),
    body: String(v.body),
    slug: String(v.slug),
    code: String(v.code),
    statusId: String(v.statusId),
  });

const config: ListPageConfig<Category> = {
  queryKey: LIST_KEY,
  title: 'Категории',
  boxTitle: 'Категории',
  errorText: 'Ошибка загрузки категорий',
  fetchList: postListFetcher('/publication/category/index/'),
  rows: ['items'],
  headerActions: (
    <FormModalButton
      buttonLabel="Создать"
      buttonClassName="btn btn-info pull-right"
      title="Создать категорию"
      fields={FIELDS}
      initial={toValues()}
      save={save()}
      listKey={LIST_KEY}
    />
  ),
  columns: [
    { header: 'id', render: (category) => category.id },
    { header: 'Заголовок', render: (category) => category.title || 'No title' },
    { header: 'Тело', render: (category) => category.body || 'No body' },
    { header: 'ЧПУ', render: (category) => category.slug || 'No slug' },
    { header: 'Статус', render: (category) => category.status_id },
    {
      header: 'Edit',
      render: (category) => (
        <FormModalButton
          buttonLabel="Edit"
          title="Редактировать категорию"
          fields={FIELDS}
          initial={toValues(category)}
          save={save(category.id)}
          listKey={LIST_KEY}
        />
      ),
    },
    {
      header: 'Delete',
      render: (category) => (
        <DeleteButton listKey={LIST_KEY} remove={() => deleteCategory(category.id)} />
      ),
    },
  ],
};

export const CategoriesPage = () => <GenericListPage config={config} />;
